<template>
  <div id="app">
    <!-- Top navigation bar for small screen or mobile screen -->
    <nav-bar v-if="isSmallScreen"></nav-bar>
    <!-- Main route view component -->
    <component :is="layout" :key="$route.fullPath">
      <router-view :key="$route.fullPath"></router-view>
    </component>

    <!-- Footer -->
    <footer
      class="footer"
      style="position: absolute; bottom: 0"
      v-if="$route.fullPath == '/login' && !isSmartphoneDevice"
    >
      <div class="container-fluid">
        <div class="row row justify-content-md-center">
          <div class="col-md-auto">
            <span>{{ $t('footer', [pkg.version]) }} - {{ env }}</span>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer" v-if="$route.fullPath != '/login'">
      <div class="container-fluid">
        <div class="row row justify-content-md-center">
          <div class="col-md-auto">
            <img src="/img/logo_histovery.png" width="80" />
            <span> - {{ $t('footer', [pkg.version]) }} - {{ env }}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import pkg from '../package.json'
import { utilsMixin } from './utils/mixins'
// import { initSession } from './utils/SessionManager'

const default_layout = 'default'

export default {
  name: 'App',
  mixins: [utilsMixin],
  data() {
    return {
      pkg: pkg,
      env: process.env.NODE_ENV,
    }
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    // if (this.getCurrentUser) {
    //   this.$log.error('App.vue initSession')
    //   await initSession()
    // }
  },
  components: {
    'nav-bar': Navbar,
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout'
    },
  },
}
</script>
